import { style, globalStyle } from '@vanilla-extract/css'
import { vars } from '../design/theme.css'
import { axisTick } from '../design/primitives/text.css'

// The activity sparkline band — the single live gesture, part of the calm day strip (static now,
// no longer sticky). The window picker sits in its head.
export const band = style({ display: 'flex', flexDirection: 'column', gap: vars.space[2] })
export const head = style({
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  gap: `${vars.space[1]} ${vars.space[4]}`,
})
// The date ticks under the line — the shared axis-tick treatment, so Live's chart and Stats'
// are set in the same hand (§9/§11). They were two independent copies of the same three values,
// neither of them tabular, so the ticks under a line of dates sat at uneven widths.
export const anchors = style([
  axisTick,
  { position: 'relative', height: vars.space[4], marginTop: vars.space[1] },
])
// The tick spans are absolutely placed; their left/transform are data-driven (set inline).
globalStyle(`${anchors} span`, { position: 'absolute', top: 0, whiteSpace: 'nowrap' })
